// extracted by mini-css-extract-plugin
module.exports = {"vantageBlue":"#3f1f5a","dataset-menu":"DatasetMenu_dataset-menu__1-oW_","first-item":"DatasetMenu_first-item__1GrTQ"};